import axios from "axios";
import React, { useEffect,useState } from "react";
import LoadingScreen from "./LoadingScreen";
import "../css/DepartmentWiseSales.css";

function DepartmentWiseSales(){

    const [dateFormatError, setDateFormatError] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [listOfSales, setListOfSales] = useState([]);
    const [listOfDepartments, setListOfDepartments] = useState([]);
    const [currentSelectedDepartmentId, setCurrentSelectedDepartmentId] = useState(0);
    
    const [showDepartmentDropDown, setShowDepartmentDropDown] = useState(false);
    const initialInputDateState = {
        fromDate: "",
        toDate:""
    }

    const[inputDateState, setInputDateState] = useState(initialInputDateState)

    function dateIsValid(dateStr) {
        const regex = /^\d{2}-\d{2}-\d{4}$/;
      
        if (dateStr.match(regex) === null) {
          return false;
        }
      
        const [month, day, year] = dateStr.split('-');
      
        // 👇️ format Date string as `yyyy-mm-dd`
        const isoFormattedStr = `${year}-${month}-${day}`;
      
        const date = new Date(isoFormattedStr);
        console.log(date); // 👉️ Invalid Date
      
        const timestamp = date.getTime();
        console.log(timestamp); // 👉️ NaN
      
        if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
          // 👇️ this runs
          return false;
        }
      
        return date.toISOString().startsWith(isoFormattedStr);
      }

    const filterBranchWiseResult = ()=>{

        let branchName = listOfDepartments[currentSelectedDepartmentId].deptno;
        let startDate = inputDateState.fromDate;
        let endDate = inputDateState.toDate;

        console.log("from date is ", dateIsValid(startDate))

        console.log("to date is ", dateIsValid(endDate))

        console.log("current state of input filter ", branchName.trim(), startDate, endDate);

        if(dateIsValid(startDate) && dateIsValid(endDate)){

            setIsSending(true);
            
            if(branchName != "ALL"){
                axios.get(`${process.env.REACT_APP_BASE_URL}/SalesDepartment?Branch=${branchName}&dateStart=${startDate}&dateEnd=${endDate}`).
                then((res)=>{
                    setIsSending(false);
                    console.log("filter res is ", res);
                    setListOfSales(res.data);
                }
                ).catch((err) => {
                    setIsSending(false);
                    console.log("err is ", err);
                })
            }

            if( branchName == "ALL"){
                
                axios.get(`${process.env.REACT_APP_BASE_URL}/SalesDepartment/All/Dept?dateStart=${startDate}&dateEnd=${endDate}`).
                then((res)=>{
                    setIsSending(false);
                    console.log("filter res is ", res);
                    setListOfSales(res.data);
                }
                ).catch((err) => {
                    setIsSending(false);
                    console.log("err is ", err);
                })
            }

        }else{
            setDateFormatError("please enter date in valid format");
        }

    }

    const getDepartmentWiseResult =()=>{

        setIsSending(true);

        axios.get(`${process.env.REACT_APP_BASE_URL}/SalesDepartment/Department`).
        then((res)=>{

            setIsSending(false);
            setListOfSales(res.data.jsont);

            res.data.jsonw.unshift({deptno:"ALL"});
            setListOfDepartments(res.data.jsonw);
            console.log("department result is ", res);


        }).catch((err) =>{

            setIsSending(false);
         console.log("the error is ", err);
        })
    }

    const resetAllFilter =()=>{

        setDateFormatError("");

        // reset position to 0 so "ALL" will be shown in branch name
        // and empty input boxes are shown
        setCurrentSelectedDepartmentId(0);
        setInputDateState(initialInputDateState);
        getDepartmentWiseResult();
    }
   const handleDropDownItemClick =(e)=>{
    
    console.log("clicked on item ", e.target.id);
    setCurrentSelectedDepartmentId(parseInt(e.target.id));
    setShowDepartmentDropDown((prev) => !prev);
   }

   const handleInputDate = (e)=>{

    setDateFormatError("");
    console.log("e.target name is ", e.target.name);
    console.log("e.target value is ", e.target.value);

    setInputDateState({...inputDateState, [e.target.name]:e.target.value});

   }

    useEffect(()=>{

        getDepartmentWiseResult();

    }, [])

    return(
        <div className="DepartmentWiseSales-root-container">
            

{listOfDepartments != null ? 
                    listOfDepartments.length > 0 ?
                            <div>
                                <div className="DepartmentWiseSales-filter-container mt-2">

                                    <div className="DepartmentWiseSales-dropdown-name-and-list-container">
                                        <label className="ms-4">
                                            Select department
                                        </label>

                                        <div className="DepartmentWiseSales-dropdown-and-current-value-container">
                                            <label className="DepartmentWiseSales-current-branchname ms-2" onClick={()=>setShowDepartmentDropDown((prev) => !prev)}>
                                                {
                                                    listOfDepartments.length > 0 ? 
                                                        listOfDepartments[currentSelectedDepartmentId].deptno
                                                        :
                                                        "---"
                                                }
                                            </label>
                                            {showDepartmentDropDown && 
                                            <div className="DepartmentWiseSales-branch-drop-down-container">
                                            {
                                                listOfDepartments != null ? 
                                                listOfDepartments.map((item, index)=>{
                                                    return(
                                                        <div className="DepartmentWiseSales-list-single-row" id={index} onClick={(e)=>handleDropDownItemClick(e)}>
                                                            {item.deptno}
                                                        </div>
                                                    )
                                                })
                                                :
                                                null
                                            }
                                            </div>  
                                            } 
                                        </div>
                                    </div>

                                    <span className="ms-4 from-to-date-input-container">
                                        
                                        <label>Enter From date</label>
                                        <input className="ms-2" name="fromDate" value={inputDateState.fromDate} type="text" placeholder="MM-DD-YYYY" onChange={handleInputDate}/>
                                        <label className="ms-4">Enter To date</label>
                                        <input className="ms-2" name="toDate" value={inputDateState.toDate} type="text" placeholder="MM-DD-YYYY" onChange={handleInputDate}/>
                                    </span>

                                        <div className="DepartmentWiseSales-filter-reset-button-container">
                                        <span>
                                            <label className="DepartmentWiseSales-filter-button ms-2" onClick={filterBranchWiseResult}>
                                                Filter
                                            </label>
                                        </span> 
                                        <span>
                                            <label className="DepartmentWiseSales-reset-button ms-2" onClick={resetAllFilter}>
                                                Reset
                                            </label>
                                        </span> 
                                        </div>

                                </div>
                                <div className=" ms-4 me-4 DepartmentWiseSales-dater-error-container">
                                    <p className="text-center ">{dateFormatError}</p>
                                </div>
                        </div>
                    :
                    null
                :
                null
            }

                <div className="DepartmentWiseSales-table-container">

                {isSending ? 
                    <LoadingScreen />
                     :

                        listOfSales != null ?
                        <table className="HomePage-table">
                                <thead>
                                            <tr>
                                                <th>DEPTNO</th>
                                                <th>CASHSALES%</th>
                                                <th>CREDITSALES%</th>
                                                <th>NET SALES</th>
                                                <th>NETCASH SALES</th>
                                                <th>NETCREDIT SALES</th>
                                            </tr>
                                </thead>
                                <tbody>
                                    {listOfSales.map((item)=>{
                                        return(
                                            <tr>
                                                <td>{item.DEPTNO}</td>
                                                <td>{item['CASHSALES%']}</td>
                                                <td>{item['CREDITSALES%']}</td>
                                                <td>{item['NET SALES']}</td>
                                                <td>{item['NETCASH SALES']}</td>
                                                <td>{item['NETCREDIT SALES']}</td>
                                            </tr>
                                        
                                        )
                            
                                     })}
                        </tbody>
                                    </table>
                                    
                                    :
                                    null
                    }
                
                </div>
        </div>
    )
}

export default DepartmentWiseSales;